import type { TileableModel } from '@rocco/ui/tile-shared/view-models/tile';
import type { ImageModel } from '@rocco/types/image-model';

export interface ArticleTileViewModel {
    id: number;
    title: string;
    /** Optional intro/standfirst text used by editorial tile variants. */
    introText?: string;
    label: string;
    link: string;
    image: ImageModel;
    video: string[];
    category: string;
    categoryLabel: string;
    date: string;
    readTime: string;
    homePinned: boolean;
    professional: {
        id: number;
        name: string;
    };
    badge: string | null;
    /**
     * The article's banner is a video. Editorial tiles carry a play affordance
     * over the still for these; the still itself is unchanged, so the card
     * stays a card rather than becoming a player.
     */
    hasVideo?: boolean;
    /**
     * `editorial` is the 2026 article-directory treatment: image above a serif
     * title and a date + read-time meta line, in place of the overlaid
     * `featured` card and the `default` "written by" line.
     */
    variant?: 'featured' | 'default' | 'editorial' | 'editorialLarge';
}

export const isArticleTileViewModel = (
    model: TileableModel,
): model is ArticleTileViewModel => 'date' in model && 'readTime' in model;
